var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExcel = function SvgExcel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 33.49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#21a366;}.cls-4{fill:#107c41;}.cls-5{fill:#185c37;}.cls-6{fill:#33c481;}.cls-7{opacity:.1;}.cls-7,.cls-8{isolation:isolate;}.cls-8{opacity:.2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5632.63,
    y1: 810.66,
    x2: 5680.63,
    y2: 893.79,
    gradientTransform: "translate(-1407.16 -196.65) scale(.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.6,15.91l-14.23-2.51v18.56c0,.85.69,1.53,1.53,1.53h24.56c.85,0,1.53-.69,1.53-1.53v-6.84l-13.4-9.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.6,0h-12.7c-.85,0-1.53.69-1.53,1.53v6.84l14.23,8.37,7.53,2.51,5.86-2.51v-8.37L22.6,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m8.37,8.37h14.23v8.37h-14.23v-8.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m18.56,6.7h-10.19v20.93h10.19c.85,0,1.53-.69,1.53-1.53V8.23c0-.85-.69-1.53-1.53-1.53h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m17.72,7.53h-9.35v20.93h9.35c.85,0,1.53-.69,1.53-1.53V9.07c0-.85-.69-1.53-1.53-1.53h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m17.72,7.53h-9.35v19.26h9.35c.85,0,1.53-.69,1.53-1.53V9.07c0-.85-.69-1.53-1.53-1.53h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m16.88,7.53h-8.51v19.26h8.51c.85,0,1.53-.69,1.53-1.53V9.07c0-.85-.69-1.53-1.53-1.53h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.53,7.53h15.35c.85,0,1.53.69,1.53,1.53v15.35c0,.85-.69,1.53-1.53,1.53H1.53c-.85,0-1.53-.69-1.53-1.53v-15.35c0-.85.69-1.53,1.53-1.53Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m4.75,21.73l3.23-5-2.96-4.98h2.38l1.61,3.18c.15.3.25.53.31.67h.02c.1-.24.22-.47.33-.7l1.73-3.15h2.18l-3.03,4.95,3.11,5.03h-2.32l-1.86-3.49c-.09-.15-.16-.3-.22-.47h-.03c-.05.16-.13.31-.22.45l-1.92,3.51h-2.34Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m34.47,0h-11.86v8.37h13.4V1.53c0-.85-.69-1.53-1.53-1.53Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m22.6,16.74h13.4v8.37h-13.4v-8.37Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excel.7b7d98580fafd197ec48f0dad624d0de.svg";